import { render } from "./AssignedTraining.vue?vue&type=template&id=905d49ea"
import script from "./AssignedTraining.vue?vue&type=script&lang=js"
export * from "./AssignedTraining.vue?vue&type=script&lang=js"

import "./AssignedTraining.vue?vue&type=style&index=0&id=905d49ea&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__